import { Component, Input } from '@angular/core';
import { PrinterStatus } from '@models/system-status';

@Component({
    selector: 'app-printers-status',
    templateUrl: './printers-status.component.html',
    styleUrls: ['./printers-status.component.scss'],
    standalone: false
})
export class PrintersStatusComponent {
    @Input() printerArray: PrinterStatus[];
    @Input() isReceivingData: boolean;
}
